import {
  Badge,
  Box,
  Button,
  CloseButton,
  Divider,
  HStack,
  IconArrowBack,
  IconFilter,
  IconOrder,
  IconTrash,
  Radio,
  RadioGroup,
  Slide,
  Text,
  VStack,
  useDisclosure,
} from '@gazin/ecommerce-ui'
import { useRouter } from 'next/router'
import { Fragment, useEffect, useState } from 'react'
import {
  Filter,
  SelectedFiltersByLinx,
} from 'src/services/linx-api/dtos/search-products-response'
import { FilterProduct } from 'src/templates/SearchAndCategory'
import { formatarPreco } from 'src/util/formatar'
import { Accordion } from '../accordion'
import FilterProductMobile from './filterProductMobile'
import { ProductsSortingKey } from 'src/util/enums/products-sorting-key'

interface FiltersProductsMobileProps {
  arrayFilters: Partial<FilterProduct>[]
  changeOrdination: (ordination: string) => void
  clearFilters: () => void
  filters: Filter[]
  selectedFilterByLinx?: SelectedFiltersByLinx[]
  selectFilter: (filters: any[]) => void
}

export default function FiltersProductsMobile({
  arrayFilters,
  changeOrdination,
  clearFilters,
  filters,
  selectedFilterByLinx,
  selectFilter,
}: FiltersProductsMobileProps) {
  const [isFiltering, setIsFiltering] = useState(false)
  const [isOrdering, setIsOrdering] = useState(false)
  const [orderValue, setOrderValue] = useState('')
  const [selectedFilters, setSelectedFilters] = useState<
    Partial<FilterProduct>[]
  >([])

  const route = useRouter()
  const routeParams = route.asPath.split('?')
  const paramsUrl = new URLSearchParams(routeParams[1])
  const order = paramsUrl.get('order')

  const { isOpen } = useDisclosure({
    isOpen: isFiltering || isOrdering,
  })

  const handleApplyFilters = () => {
    selectFilter(selectedFilters)
    setIsFiltering(false)
  }

  function handleRemoveFilterMobile(id_atributo: any) {
    const indexFilterWithIdAtributo = selectedFilters.findIndex(
      (item: any) => item?.id_atributo === id_atributo
    )
    const copySelectedFilters = selectedFilters.slice(0)
    copySelectedFilters.splice(indexFilterWithIdAtributo, 1)

    setSelectedFilters(copySelectedFilters)
  }

  function renderOrderDescription(order: string) {
    switch (order) {
      case ProductsSortingKey.Relevance:
        return 'Populares'
      case ProductsSortingKey.DescPrice:
        return 'Maior preço'
      case ProductsSortingKey.AscPrice:
        return 'Menor preço'
      case ProductsSortingKey.DescDiscount:
        return 'Maiores desc.'
      default:
        return ''
    }
  }

  useEffect(() => {
    const header: any = document.querySelector('.cabecalho-paginas')
    const body: any = document.querySelector('body')
    if (isOpen) {
      header.style.position = 'relative'
      header.style.zIndex = '5'
      body.style.maxHeight = '100%'
      body.style.overflow = 'hidden'
    } else {
      header.style.display = 'flex'
      body.style.overflow = 'auto'
    }
  }, [isOpen])

  useEffect(() => {
    setOrderValue(order ?? '')
  }, [order])

  useEffect(() => {
    setSelectedFilters(arrayFilters)
  }, [arrayFilters])

  return (
    <VStack w="100%">
      {route.query.busca && (
        <HStack spacing={2} alignItems="flex-start" w="100%">
          <Text fontSize="1rem" fontWeight={600} color="#363843">
            Você pesquisou por ‘
            <Text fontSize="1rem" fontWeight={600} color="#0D71F0" as="span">
              {`${route.query.busca?.[0]}`}
            </Text>
            ’
          </Text>
        </HStack>
      )}
      <HStack width="100%" gap="0.3125rem" marginBottom="0.5rem">
        <Button
          width="50%"
          bgColor={`${isOrdering ? '#0D71F0' : 'white'}`}
          variant="outline"
          color="#0D71F0"
          h="3rem"
          rightIcon={<IconOrder />}
          onClick={() => setIsOrdering(true)}
        >
          {order ? renderOrderDescription(order) : 'Ordenar'}
        </Button>
        <Button
          width="50%"
          bgColor={`${isFiltering ? '#0D71F0' : 'white'}`}
          variant="outline"
          color="#0D71F0"
          h="3rem"
          onClick={() => setIsFiltering(true)}
          gap="0.5rem"
        >
          Filtrar
          <Box position="relative">
            <IconFilter color="#0D71F0" />
            {selectedFilters.length > 0 && (
              <Badge
                bg="secondary.600"
                w="1rem"
                h="1rem"
                display="flex"
                alignItems="center"
                justifyContent="center"
                rounded="full"
                color="neutral.0"
                fontFamily="body"
                fontSize="0.5rem"
                lineHeight="1.5rem"
                right={0}
                top={0}
                position="absolute"
              >
                {selectedFilters.length}
              </Badge>
            )}
          </Box>
        </Button>
      </HStack>

      <Slide
        direction="bottom"
        in={isOpen}
        style={{ backgroundColor: 'white', zIndex: 10 }}
      >
        <VStack h="100vh">
          <HStack
            h="6rem"
            pb="1.125rem"
            pt="3.625rem"
            w="100%"
            bg="linear-gradient(90deg, #5C33FF 3.91%, #39F 98.18%)"
          >
            <HStack
              w="56%"
              pl="1.125rem"
              alignItems="center"
              justifyContent="space-between"
            >
              <IconArrowBack
                color="neutral.0"
                w="0.4569rem"
                h="0.875rem"
                onClick={() => {
                  setSelectedFilters(arrayFilters)
                  setIsFiltering(false)
                  setIsOrdering(false)
                }}
              />
              <Text
                fontFamily="body"
                fontSize="1rem"
                fontWeight="600"
                lineHeight="1.25rem"
                textAlign="center"
                color="neutral.0"
                ml="auto"
              >
                {isOrdering ? 'Ordenar' : isFiltering && 'Filtrar'}
              </Text>
            </HStack>
          </HStack>

          <VStack
            css={`
              &::-webkit-scrollbar {
                display: none;
              }
            `}
            flex="1"
            overflow="scroll"
            pb="12rem"
            w="100%"
          >
            {selectedFilters.length > 0 && isFiltering && (
              <VStack
                w={{ base: '100%', md: '19.375rem' }}
                h={{ base: 'fit-content', md: '11.875rem' }}
                gap="1rem"
                alignItems="flex-start"
                px={{ base: '1rem', md: 0 }}
              >
                <Text
                  mb={0}
                  fontSize="0.875rem"
                  fontFamily="body"
                  lineHeight="1.5rem"
                  color="neutral.600"
                  fontWeight="600"
                >
                  Filtros selecionados
                </Text>
                <HStack
                  mt="0rem !important"
                  flexWrap="wrap"
                  h="fit-content"
                  w="100%"
                  columnGap="0.5rem"
                  rowGap="1rem"
                >
                  {selectedFilters?.map((filtro: any, index: any) => (
                    <Fragment key={index}>
                      <Badge
                        variant="outline"
                        rounded="31.25rem"
                        py="0.375rem"
                        px="0.75rem"
                        pr="0.875rem"
                        bg="white"
                        border="0.0625rem solid neutral.600"
                        display="flex"
                        alignItems="center"
                        fontFamily="body"
                        fontSize="0.75rem"
                        lineHeight="0.9rem"
                        fontWeight="400"
                        gap="0.5rem"
                        key={`filtro-${index}`}
                        justifyContent="center"
                      >
                        {filtro.valor_minimo && filtro.valor_minimo != '' ? (
                          filtro.valor_maximo && filtro.valor_maximo != '' ? (
                            <Text
                              mb={0}
                              textTransform="initial"
                              maxW="16rem"
                              w="100%"
                              textOverflow="ellipsis"
                              overflow="clip"
                              minH="17px"
                              textAlign="center"
                            >
                              {`${
                                filtro.attribute == 'Preço' ||
                                filtro.descricao == 'Preço'
                                  ? formatarPreco(filtro.valor_minimo)
                                  : filtro.valor_minimo
                              } - ${
                                filtro.attribute == 'Preço' ||
                                filtro.descricao == 'Preço'
                                  ? formatarPreco(filtro.valor_maximo)
                                  : filtro.valor_maximo
                              }`}
                            </Text>
                          ) : (
                            <Text mb={0}>{`${filtro.valor_minimo}`}</Text>
                          )
                        ) : filtro.label && filtro.label != '' ? (
                          <Text
                            mb={0}
                            textTransform="initial"
                            maxW="16rem"
                            w="100%"
                            textOverflow="ellipsis"
                            overflow="clip"
                            minH="17px"
                            textAlign="center"
                          >{`${
                            filtro.type === 'continuous'
                              ? filtro.label
                              : `${
                                  filtro.descricao
                                    ? filtro.descricao
                                    : filtro.attribute
                                }: ${filtro.label}`
                          }`}</Text>
                        ) : null}
                        <CloseButton
                          size="md"
                          w="0.7rem"
                          h="0.7rem"
                          objectFit="contain"
                          overflow={'hidden'}
                          _hover={{ bg: 'transparent' }}
                          onClick={() =>
                            handleRemoveFilterMobile(filtro?.id_atributo)
                          }
                        />
                      </Badge>
                    </Fragment>
                  ))}
                </HStack>
              </VStack>
            )}
            {isOrdering ? (
              <RadioGroup
                onChange={setOrderValue}
                value={orderValue || ProductsSortingKey.Relevance}
                w="100%"
                p="1rem"
                mt="2rem"
              >
                <VStack
                  spacing="1rem"
                  alignItems="flex-start"
                  justifyContent="flex-start"
                >
                  <Radio
                    size="lg"
                    fontFamily="body"
                    fontSize="0.875rem"
                    lineHeight="1.125rem"
                    color="neutral.700"
                    value={ProductsSortingKey.Relevance}
                  >
                    Populares
                  </Radio>
                  <Divider m={0} bg="#E3E3E8" opacity={0.3} w="100%" />
                  <Radio
                    size="lg"
                    fontFamily="body"
                    fontSize="0.875rem"
                    lineHeight="1.125rem"
                    color="neutral.700"
                    value={ProductsSortingKey.DescPrice}
                  >
                    Maior preço
                  </Radio>
                  <Divider m={0} bg="#E3E3E8" opacity={0.3} w="100%" />
                  <Radio
                    size="lg"
                    fontFamily="body"
                    fontSize="0.875rem"
                    lineHeight="1.125rem"
                    color="neutral.700"
                    value={ProductsSortingKey.AscPrice}
                  >
                    Menor Preço
                  </Radio>
                  <Divider m={0} bg="#E3E3E8" opacity={0.3} w="100%" />
                  <Radio
                    size="lg"
                    fontFamily="body"
                    fontSize="0.875rem"
                    lineHeight="1.125rem"
                    color="neutral.700"
                    value={ProductsSortingKey.DescDiscount}
                  >
                    Maiores descontos
                  </Radio>
                </VStack>
              </RadioGroup>
            ) : (
              <Accordion>
                {filters?.map((item, index: number) => (
                  <Fragment key={index}>
                    <FilterProductMobile
                      filter={item}
                      isFilteringMobile={isFiltering}
                      key={index}
                      keyFilter={index}
                      selectedFilterByLinx={selectedFilterByLinx}
                      selectedFilters={selectedFilters}
                      setSelectedFilters={setSelectedFilters}
                    />

                    <Divider
                      m={0}
                      bg="neutral.800"
                      opacity={0.3}
                      w="100%"
                      display={`${
                        filters.length - 1 === index ? 'none' : 'block'
                      }`}
                    />
                  </Fragment>
                ))}
              </Accordion>
            )}
          </VStack>
        </VStack>

        <HStack
          alignItems="flex-start"
          bg="white"
          bottom={0}
          boxShadow="0rem -0.25rem 0.75rem 0rem rgba(25, 28, 87, 0.08)"
          gap="0.3125rem"
          h="6rem"
          position="fixed"
          px="1rem"
          pt="1.2rem"
          width="100%"
          zIndex={10}
        >
          {isFiltering ? (
            <>
              <Button
                width="50%"
                variant="outline"
                color="#0D71F0"
                h="3rem"
                leftIcon={<IconTrash />}
                onClick={clearFilters}
                borderColor="primary.500"
                px="1rem"
                py="1.0938rem"
              >
                Limpar filtros
              </Button>
              <Button
                width="50%"
                bgColor="#0D71F0"
                color="white"
                h="3rem"
                onClick={handleApplyFilters}
              >
                Aplicar
              </Button>
            </>
          ) : (
            <Button
              width="100%"
              bgColor="#0D71F0"
              color="white"
              h="3rem"
              onClick={() => {
                changeOrdination(orderValue)
                setIsOrdering(false)
              }}
            >
              Aplicar
            </Button>
          )}
        </HStack>
      </Slide>
    </VStack>
  )
}
